/* Concepts 5.x Mega Menu (Desktop Only)
   - Opens submenus on hover with small delays
   - Never blocks clicks on child links
   - No slope math; simple timers with a lightweight "lock" after open
*/
(() => {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const OPEN_DELAY = 75;     // quick, snappy
  const CLOSE_DELAY = 280;   // gives users time to move into submenu
  const LOCK_AFTER_OPEN = 120;

  // Selectors must match your header markup
  const header = document.querySelector('header, .site-header, .Header');
  if (!header) return;

  const root = header;
  const parents = root.querySelectorAll(
    '.mega, .has-mega, .has-children, li.has-children, [data-has-children="true"]'
  );

  let openTimer = null;
  let closeTimer = null;
  let locked = false;
  let current = null;

  const clearTimers = () => {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  };

  const openItem = (el) => {
    if (current === el) return;
    closeAll();
    current = el;
    el.classList.add('is-open');
    const toggle = el.querySelector('[aria-haspopup="true"], [data-toggle="submenu"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    locked = true;
    setTimeout(() => { locked = false; }, LOCK_AFTER_OPEN);
  };

  const closeAll = () => {
    root.querySelectorAll('.is-open').forEach((n) => {
      n.classList.remove('is-open');
      const toggle = n.querySelector('[aria-haspopup="true"], [data-toggle="submenu"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    current = null;
  };

  parents.forEach((item) => {
    // Ensure the parent has the right semantics
    const toggle = item.querySelector(':scope > a, :scope > button, :scope > .nav-link');
    const submenu = item.querySelector(':scope .submenu, :scope .mega-menu, :scope .MegaPanel');
    if (toggle) {
      toggle.setAttribute('aria-haspopup', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      // IMPORTANT: do NOT preventDefault on desktop anchors.
      // We only care about hover here. Leave clicks alone.
      toggle.addEventListener('click', (e) => {
        // If your design wants clicks to follow links on desktop, do nothing.
        // If you need click-to-open behavior, only do it when no href or href === '#'.
        const href = (toggle.getAttribute('href') || '').trim();
        if (!href || href === '#') {
          e.preventDefault();
          item.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
        }
      });
    }

    // Hover behavior
    item.addEventListener('mouseenter', () => {
      clearTimers();
      openTimer = setTimeout(() => openItem(item), OPEN_DELAY);
    });

    item.addEventListener('mouseleave', (ev) => {
      clearTimers();
      // If user quickly re-enters, don't slam it shut
      closeTimer = setTimeout(() => {
        if (!locked) closeAll();
      }, CLOSE_DELAY);
    });

    // Make sure nothing inside submenu blocks clicks
    if (submenu) {
      // Nested links must *not* be prevented from clicking
      submenu.addEventListener('click', (ev) => {
        // Do not stopPropagation or preventDefault—let links work normally
        // Some themes added stopPropagation here; we explicitly avoid that.
      });

      // Defensive: ensure submenu itself accepts pointer events
      submenu.style.pointerEvents = 'auto';
    }
  });

  // Close menus when clicking outside header
  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) closeAll();
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
